import { render, staticRenderFns } from "./MenuStatic.vue?vue&type=template&id=a0b96138&scoped=true"
import script from "./MenuStatic.vue?vue&type=script&lang=js"
export * from "./MenuStatic.vue?vue&type=script&lang=js"
import style0 from "./MenuStatic.vue?vue&type=style&index=0&id=a0b96138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b96138",
  null
  
)

export default component.exports